export const routes = [
  {
    path: '/events/:id',
    name: 'EventCard',
    component: () => import('@/app/modules/Events/views/EventCard.vue'),
  },
];
